const contactConstraints = function (locale) {

  const constraints = {
    "dwfrm_register_privacyTerms": {
      presence: {
        allowEmpty: false,
      },
    },

    "dwfrm_register_privacyTermsInsideCN": {
      presence: {
        allowEmpty: false,
      },
    },

    "dwfrm_register_privacyTermsOutsideCN": {
      presence: {
        allowEmpty: false,
      },
    },

    "dwfrm_contact_email": {
      email: true,
      presence: {
        allowEmpty: false,
      },
    },
    "dwfrm_contact_phone": {
      presence: {
        allowEmpty: false,
      },
    },
    "dwfrm_contact_title": {
      presence: {
        allowEmpty: false,
      },
    },
    "dwfrm_contact_firstName": {
      presence: {
        allowEmpty: false,
      },
    },
    "dwfrm_contact_lastName": {
      presence: {
        allowEmpty: false,
      },
    },
    "dwfrm_contact_country": { // Country input import from contact.xml
      presence: {
        allowEmpty: false,
      },
    },
    "dwfrm_contact_userProfile": { // userProfile input import from contact.xml - arclinea
      presence: {
        allowEmpty: false,
      },
    },
    "dwfrm_contact_theme": { // theme input import from contact.xml - arclinea
      presence: {
        allowEmpty: false,
      },
    },
    "dwfrm_newsletter_country": { // DHCorp uses country dropdown import from newsletter.xml
      presence: {
        allowEmpty: false,
      },
    },
    "dwfrm_contact_message": {
      presence: {
        allowEmpty: false,
      },
    }
  }

  switch (locale) {
    case 'CN':
      constraints.dwfrm_contact_email = {}
      break;
    default:
      break;
  }
  return constraints;
};

export default contactConstraints;
